import { render, staticRenderFns } from "./KYCStatusReviewPopup.vue?vue&type=template&id=93b8cfba&"
import script from "./KYCStatusReviewPopup.vue?vue&type=script&lang=js&"
export * from "./KYCStatusReviewPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports